import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    user: null,
  }),
  getters: {
    /**
     * Checks if the user is authenticated.
     * @returns {boolean} True if a token exists, false otherwise.
     */
    isAuthenticated: (state) => !!state.token,
    /**
     * Gets the user's name.
     * @returns {string | null} The user's name or null if no user/name.
     */
    userName: (state) => state.user?.name || null, // Access name safely
    /**
     * Gets the full user object.
     * @returns {object | null} The user object or null.
     */
    currentUser: (state) => state.user,
  },
  actions: {
    /**
     * Initializes authentication state from localStorage.
     * Called when the application loads.
     */
    initializeAuth() {
      const storedToken = localStorage.getItem('authToken');
      const storedUser = localStorage.getItem('user');

      if (storedToken) {
        this.token = storedToken;
      }
      if (storedUser) {
        try {
          this.user = JSON.parse(storedUser);
        } catch (e) {
          console.error('AuthStore: Error parsing stored user data', e);
          this.user = null; // Clear invalid user data
          localStorage.removeItem('user'); // Remove invalid entry
        }
      }
      console.log('[AuthStore] Initialized. Token:', !!this.token, 'User:', this.user?.name || 'Guest');
    },
    /**
     * Logs in the user.
     * @param {object} tokenObject - The authentication token object from backend (e.g., { access_token: "...", token_type: "..." }).
     * @param {object} userData - The user object.
     */
    login(tokenObject, userData) { // Renamed tokenData to tokenObject for clarity
      this.token = tokenObject.access_token; // Store the actual token string
      this.user = userData;

      localStorage.setItem('authToken', tokenObject.access_token); // Store the actual token string
      localStorage.setItem('user', JSON.stringify(userData));
      console.log('[AuthStore] User logged in:', this.user?.name);
    },
    /**
     * Logs out the user.
     */
    logout() {
      const loggedOutUserName = this.user?.name || 'User';
      this.token = null;
      this.user = null;

      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      console.log(`[AuthStore] ${loggedOutUserName} logged out.`);
      // Optionally, you might want to redirect here or let the component handle it.
      // For now, just clearing state.
    },
  },
});
